import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import isToday from 'dayjs/plugin/isToday'
import 'dayjs/locale/pt-br'

dayjs.extend(relativeTime)
dayjs.extend(isToday)

dayjs.locale('pt-br')

const filter = (value, type, format?): string => {
  if (!value) {
    return ''
  }

  const day = dayjs(value)
  
  if (format) {
    return day.format(format)
  }

  if (format) {
    return day.format(format)
  }

  switch (type) {
    case 'base':
      return day.format('YYYY-MM-DD')

    case 'date':
      return day.format('DD/MM/YYYY')

    case 'date-fancy':
      return day.format('DD MMM YYYY')

    case 'date-short':
      return day.format('DD/MM/YY')

    case 'datetime':
      return day.format('DD/MM/YYYY HH:mm:ss')

    case 'datetime-short':
      return day.format('DD/MM/YYYY HH:mm')

    case 'datetime-small':
      return day.format('DD/MM/YY - HH:mm')

    case 'time':
      return day.format('HH:mm')

    case 'full':
      return day.format('dddd - DD/MM/YYYY HH:mm')

    default:
      return day.isToday()
        ? 'Hoje'
        : day.format('DD/MM/YYYY')
  }
}

export default filter
